import {useState} from 'react';

import {useTranslation} from 'react-i18next';

import {Divider, Grid, Typography} from '@mui/material';

import {DeleteAccountAlert} from '../DeleteAccountAlert/DeleteAccountAlert';

import {EmpionButton} from '../../../../../../components/EmpionButton/EmpionButton';
import {greenColors} from '../../../../../../layouts/theme/designSystem';

export const AccountManagement = () => {
  const {t} = useTranslation();

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const onClose = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Grid container data-testid='account-management'>
        <Grid item container xs={12} justifyContent={'space-between'} alignItems={'flex-end'} mb={2}>
          <Grid item>
            <Typography variant='h3'>{t('settings.accountManagement.deleteAccount.title')}</Typography>
            <Typography variant='body1'>{t('settings.accountManagement.deleteAccount.subtitle')}</Typography>
          </Grid>
          <Divider
            sx={{
              width: '100%',
              marginBottom: '16px',
            }}
          />
        </Grid>
        <Grid item container xs={12} justifyContent={{xs: 'center', sm: 'flex-end'}}>
          <EmpionButton
            data-testid='delete-acct-button'
            onClick={openModal}
            hoverBackgroundColor={greenColors[100]}
            sx={{width: {xs: '100%', sm: 'auto'}, backgroundColor: greenColors[700]}}
          >
            {t('settings.accountManagement.deleteAccount.button')}
          </EmpionButton>
        </Grid>
      </Grid>
      <DeleteAccountAlert onClose={onClose} isOpen={isModalOpen} />
    </>
  );
};
